import { render, staticRenderFns } from "./RecommendetTracks.vue?vue&type=template&id=6a6ade4c&scoped=true&"
import script from "./RecommendetTracks.vue?vue&type=script&lang=js&"
export * from "./RecommendetTracks.vue?vue&type=script&lang=js&"
import style0 from "./RecommendetTracks.vue?vue&type=style&index=0&id=6a6ade4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ade4c",
  null
  
)

export default component.exports